import { render, staticRenderFns } from "./DrawAndUpload.vue.js?vue&type=template&id=1383fd3a&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DrawAndUpload.vue?vue&type=template&id=1383fd3a&scoped=true"
import script from "./DrawAndUpload.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DrawAndUpload.vue?vue&type=script&lang=js"
export * from "./DrawAndUpload.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DrawAndUpload.vue?vue&type=script&lang=js"
import style0 from "./DrawAndUpload.vue.scss?vue&type=style&index=0&id=1383fd3a&prod&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DrawAndUpload.vue?vue&type=style&index=0&id=1383fd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383fd3a",
  null
  
)

export default component.exports